export const WEBSHOP_ADD_CART_ITEM = 'WEBSHOP_ADD_CART_ITEM';
export const WEBSHOP_REMOVE_CART_ITEM = 'WEBSHOP_REMOVE_CART_ITEM';
export const WEBSHOP_CHANGE_CART_ITEM_QTY = 'WEBSHOP_CHANGE_CART_ITEM';

export const WEBSHOP_RESET = 'WEBSHOP_RESET';
